import jsPDF from "jspdf";

function escapeCsvValue(val: string): string {
  if (val.includes(",") || val.includes('"') || val.includes("\n")) {
    return `"${val.replace(/"/g, '""')}"`;
  }
  return val;
}

export function buildCsvContent(headers: string[], rows: string[][]): string {
  const lines = [headers.join(",")];
  for (const row of rows) {
    lines.push(row.map(escapeCsvValue).join(","));
  }
  return lines.join("\n");
}

export function downloadFile(content: string, filename: string, mimeType: string): void {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function exportCsv(headers: string[], rows: string[][], filename: string): void {
  const csv = buildCsvContent(headers, rows);
  downloadFile(csv, filename, "text/csv;charset=utf-8");
}

export function exportCanvasPng(canvas: HTMLCanvasElement, filename: string): void {
  const url = canvas.toDataURL("image/png");
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

interface CalendarPdfData {
  title: string;
  rows: Array<{
    brand: string;
    project: string;
    type: string;
    hub: string;
    ocdDate: string;
    deliveryDate: string;
    forecast: number;
  }>;
}

export function exportCalendarPdf(data: CalendarPdfData): void {
  const doc = new jsPDF({ orientation: "landscape" });
  const dateStr = new Date().toLocaleDateString();

  doc.setFontSize(16);
  doc.text(data.title, 14, 20);
  doc.setFontSize(9);
  doc.setTextColor(128);
  doc.text(`Generated ${dateStr}`, 14, 27);

  const headers = ["Brand", "Project", "Type", "Hub", "OCD", "Delivery", "Forecast"];
  const colWidths = [35, 55, 30, 25, 28, 28, 25];
  let y = 35;

  doc.setFontSize(8);
  doc.setTextColor(0);
  doc.setFont("helvetica", "bold");
  let x = 14;
  for (let i = 0; i < headers.length; i++) {
    doc.text(headers[i], x, y);
    x += colWidths[i];
  }
  y += 6;

  doc.setFont("helvetica", "normal");
  for (const row of data.rows) {
    if (y > 190) {
      doc.addPage();
      y = 20;
    }
    x = 14;
    const vals = [row.brand, row.project, row.type, row.hub, row.ocdDate, row.deliveryDate, String(row.forecast)];
    for (let i = 0; i < vals.length; i++) {
      doc.text(String(vals[i] || "").slice(0, 20), x, y);
      x += colWidths[i];
    }
    y += 5;
  }

  doc.save(`ecf-calendar-${new Date().toISOString().slice(0, 10)}.pdf`);
}
